<template>
  <section class="container flex flex-wrap justify-center mx-auto pt-4 px-4 lg:px-0">
    <div class="my-2 px-2 w-1/2 md:w-1/3 md:my-3 md:px-4 lg:my-4 lg:px-5 lg:w-1/4 xl:w-1/5" v-for="(u, index) in profiles" :key="index" @click="appendUser(u)">
      <div class="relative card-profile h-full cursor-pointer shadow-lg hover:shadow-2xl">
        <router-link :to="{  name: 'user', params: { lang: locale, id: u.id } }">
          <div class="w-full relative">
            <div class="absolute top-0 right-0 z-10">
              <subscription-type v-bind:user="u" ></subscription-type>
            </div>
            <div class="absolute h-full w-full flex p-2 items-end">
              <div class="w-full flex mb-20">
                <div
                  class="rounded-full h-8 w-8 flex justify-center items-center"
                  v-bind:class="u.profile.phone_validate === 1 ? 'bg-green-500 opacity-75' : 'bg-jpink-primary opacity-50'">
                  <i class="icon-celular text-white"></i>
                </div>
                <template>
                  <div class="flex flex-row items-center flex-no-wrap rounded-full ml-1">
                    <div
                      class="flex justify-center items-center h-8 w-8 rounded-full"
                      v-bind:class="u.pictures !== null ? 'bg-green-500 opacity-75' : 'bg-jpink-primary opacity-50'">
                      <img src="/storage/image/camera.png" class="w-3 h-auto self-center" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <img
              :class="(userData.profile.make_visible === 0  ||  userData.pictures.length === 0) && (userData.subscription_status ? userData.subscription_status !== 'active' : true) ? 'blurImage': ''"
              v-if="u.pictures"
              alt="Placeholder"
              class="block h-48 w-full rounded-t object-cover object-center"
              :src="u.pictures"
            />
            <img
              v-else
              alt="Placeholder"
              class="block h-48 w-full rounded-t object-cover object-center"
              src="/storage/image/placeholder-user.jpg"
            />
            <header
              class="rounded-b flex items-center justify-center flex-col leading-tight p-2 md:p-2"
            >
              <h1 class="text-base text-center font-bold w-full">
                <router-link
                  :to="{  name: 'user', params: { lang: locale, id: u.id } }"
                  class="no-underline text-jblue-primary block truncate"
                ><span title="u.username">{{ u.username }}</span></router-link>
              </h1>
              <p
                class="text-gray-700 text-jblue-primary pt-1 text-xs"
              >{{ u.profile.country.name }}</p>
              <p
                class="text-gray-700 text-jblue-primary pt-1 text-xs"
              >{{ age(u.profile.birthday, u.age) }} {{ $t('messages.general.years') }}</p>
            </header>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SubscriptionType from '@/components/SubscriptionType';
import moment from 'moment';

export default {
  name: "ProfilesGrid",
  components: {
    SubscriptionType
  },
  props: ['profiles', 'userData'],
  computed: {
    ...mapState("locale", ["locale"])
  },
  methods: {
    ...mapActions("profiles", ["getProfile", 'appendSeenUser', 'traverseToUserId']),
    ...mapActions("auth", ["updateUserConnection"]),
    onChildClick(value) {
      this.seen = value;
    },
    age(date, age) {
      if (age) {
        return age;
      }

      return parseInt(moment().format('Y'), 10) - parseInt(moment(date).format('Y'), 10);
    },
    appendUser(u) {
      this.appendSeenUser(u);
      this.traverseToUserId(u.id);
    }
  }
};
</script>

<style lang="scss">
  .card-profile {
    transition: all .3s ease-in-out;
  }
  .blurImage {
    filter: blur(10px);
  }
</style>
